
import React, { useState } from 'react'
import { ResourceButtonProps } from './types'
import {
  ResourceButtonContainer,
  ButtonText,
  ButtonImage,
  RippleEffect,
} from './styles';
import theme from '../../theme/theme';


export const ResourceButton: React.FC<ResourceButtonProps> = ({
  label = 'Button',
  icon,
  onClick = () => {},
  primaryColor = theme.color.pearl,
  primaryHoverColor = theme.color.pale,
  secondaryColor = theme.color.arctic,
  secondaryHoverColor = theme.color.pacific,
  width = 'auto',
  height = 'auto',
  borderColor = theme.color.denim,
  active = false
}) => {
  const [isActive, setIsActive] = useState(false);
  const [ripple, setRipple] = useState<{ left: number; top: number } | null>(null);

  const handleButtonClick = (event: React.MouseEvent) => {
    setIsActive(!isActive);

    // Calculate the ripple position based on the click location
    const rect = event.currentTarget.getBoundingClientRect();
    const left = event.clientX - rect.left;
    const top = event.clientY - rect.top;

    setRipple({ left, top });

    setTimeout(() => {
      setRipple(null);
    }, 600);

    onClick();
  };

  return (
    <ResourceButtonContainer
      active={active}
      primaryColor={primaryColor}
      primaryHoverColor={primaryHoverColor}
      secondaryColor={secondaryColor}
      secondaryHoverColor={secondaryHoverColor}
      width={width}
      height={height}
      borderColor={borderColor}
      onClick={handleButtonClick}
    >
      {ripple && (
        <RippleEffect
          left={ripple.left}
          top={ripple.top}
        />
      )}
      <ButtonImage src={icon} alt={label} active={isActive} />
      <ButtonText active={isActive}>{label}</ButtonText>
    </ResourceButtonContainer>
  );
};

export default ResourceButton;
